import type { NextPage } from 'next';
import { Page as Component } from '~/containers/specifics/vendors/settings/company_settings/[id]/construction_item_settings/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = (companyMasterId: number): string =>
  `/vendors/settings/company_settings/${companyMasterId}/construction_item_settings`;

const CompanySetting: NextPage = () => (
  <>
    <NskHead title="単価一覧" />
    <Component />
  </>
);

export default CompanySetting;
